import {
    DatalabFeature,
    useFetchOrganizationFreeComputeUnitsRemainingQuery,
} from "@biggeo/bg-server-lib/studio";
import {
    Button,
    ProcessingMeterCard,
    Stack,
    Typography,
} from "@biggeo/bg-ui/lab";
import { ArrowCircleUp, DnsOutline } from "@biggeo/bg-ui/lab/icons";
import { formatNumberWithPrecision, toPercentage } from "@biggeo/bg-utils";
import { isSuccess } from "@vividtheory/remotedata";
import { useFeatureAccess } from "../../paywall/redux/hooks";
import { Routes } from "../../navigation/redux/model";

export const ComputeLimitContainer = () => {
    const { featureAccess: computeFeatureAccess } = useFeatureAccess(
        DatalabFeature.datalab_compute_unit_limit
    );
    const { remote: freeComputeUnitsRd } =
        useFetchOrganizationFreeComputeUnitsRemainingQuery();

    const toPricing = () => {
        window.open(`${Routes.datalab}/pricing`, "_blank");
    };

    return (
        <ProcessingMeterCard
            type="success"
            titleSection={{
                startNode: <DnsOutline size="sm" />,
                title: "Compute",
            }}
            stats={{
                total: isSuccess(computeFeatureAccess)
                    ? computeFeatureAccess.data.featureAccess.access
                    : 0,
                used: isSuccess(computeFeatureAccess)
                    ? computeFeatureAccess.data.currentQuantity
                    : 0,
                unit: "credits",
            }}
            endNode={
                <Stack height="100%" justifyContent="space-between" gap={2}>
                    <Button
                        endNode={<ArrowCircleUp />}
                        variant="outlined"
                        density="dense"
                        color="primary"
                        onClick={toPricing}
                        fullWidth
                    >
                        Upgrade
                    </Button>
                    {isSuccess(freeComputeUnitsRd) &&
                        (freeComputeUnitsRd.data
                            .fetchOrganizationFreeComputeUnitsRemaining
                            .unitsRemaining > 0 ? (
                            <Stack
                                sx={{
                                    padding: 2,
                                    border: 1,
                                    borderColor: (theme) =>
                                        theme.palette.stroke[100],
                                    borderRadius: (theme) =>
                                        theme.radius.default,
                                }}
                            >
                                <Typography
                                    variant="body3"
                                    fontWeight="semibold"
                                >
                                    {`${formatNumberWithPrecision(freeComputeUnitsRd.data.fetchOrganizationFreeComputeUnitsRemaining.unitsRemaining)} credits`}
                                </Typography>
                                <Typography
                                    variant="body4"
                                    fontWeight="semibold"
                                    textColor="disabled.onContainer"
                                >
                                    Free trial credits
                                </Typography>
                            </Stack>
                        ) : (
                            <Stack
                                sx={{
                                    padding: 2,
                                    border: 1,
                                    borderColor: (theme) =>
                                        theme.palette.stroke[100],
                                    borderRadius: (theme) =>
                                        theme.radius.default,
                                }}
                            >
                                <Typography
                                    variant="body3"
                                    fontWeight="semibold"
                                >
                                    {isSuccess(computeFeatureAccess)
                                        ? toPercentage(
                                              computeFeatureAccess.data
                                                  .currentQuantity,
                                              computeFeatureAccess.data
                                                  .featureAccess.access
                                          )
                                        : "-"}
                                    %
                                </Typography>
                                <Typography
                                    variant="body4"
                                    fontWeight="semibold"
                                    textColor="disabled.onContainer"
                                >
                                    Used Total
                                </Typography>
                            </Stack>
                        ))}
                </Stack>
            }
        />
    );
};
